import React, { useState } from 'react';
import { Link, useNavigate  } from 'react-router-dom';
import styleHeader from './Header.module.css'; 
// import Logo from  '../../assets/logo.png'
// import Logo from  '../../assets/rtr-logo2.png'
import Logo from  '../../assets/updatelogo.svg'
import Logout from '../../assets/logout.svg'

function Header() {
  const tollfree_number = '7678123123';
  const tollfree_num_2 = '1800-313-1231';
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  const handleLogout = () => {
    // Clear session storage (or localStorage if you want)
    localStorage.clear();
    // If you're using localStorage, you can do the same
    // localStorage.clear();

    // Optionally, remove specific keys instead of clearing everything
    //localStorage.removeItem('yourKey');
    // localStorage.removeItem('yourKey');

    // Redirect to the login page
    navigate('/?action=logout'); // Adjust the path to your login page
  };
  const handleReport = ()=>{
    navigate('/admin');
  }

  return (
      // updated
    <header className={styleHeader["header-container-wrapper"]}>
    <div className={styleHeader["main-header"]}>
        <div className={styleHeader['main-content']}>
            <div className={styleHeader["logo"]}>
              <a href="/search">
                <img src={Logo} alt="BCL" />
              </a>
            </div>
          
     
            <div className={styleHeader["navbar-wrapper"]}>
              <button className={` d-md-none d-flex  ${styleHeader["mobile-menu-toggle"]}`} onClick={toggleMobileMenu}>
                ☰
              </button>
              <nav className={` d-md-block d-none    ${styleHeader["navbar"]}`}>
                <ul className={styleHeader["nav-links"]}>
                {window.location.pathname=='/search' && <li  onClick={handleReport} className={styleHeader["logoutSpan"]}>
                   Report  
                  </li>}
                <li>
                  <div onClick={handleLogout} className={styleHeader["logoutDiv"]}>
                  <img className={styleHeader["logout-img"]} src={Logout} alt="logout-icon" />
                  <span className={styleHeader["logoutSpan"]}>Logout</span>
                 </div>
                </li>
                </ul>
              </nav>
            </div>
      
      </div>
    </div>
    {isMobileMenuOpen && 
                    <nav className={` d-md-none d-block   ${styleHeader["navbar"]}`}>
                    <ul className={styleHeader["nav-links"]}>
                   {window.location.pathname=='/search' && <li  onClick={handleReport} className={styleHeader["logoutSpan"]}>
                   Report  
                  </li>}
                  <li onClick={handleLogout}>
                  <div className={styleHeader["logoutDiv"]}>
                  <img className={styleHeader["logout-img"]} src={Logout} alt="logout-icon" />
                  <span className={styleHeader["logoutSpan"]}>Logout</span>
                 </div>
                </li>
                     
                    </ul>
                  </nav>
                  }
  </header>
  );
}

export default Header;

